import * as _ from "underscore";

  // compares 2 values (simple or complex types) for equality using underscore js
  export function compareObjectsForEquality(original: any, current: any): boolean {
    return _.isEqual(original, current);
  }